import React from 'react';
import { useResponsive } from '../hooks/useResponsive';
import { useThemeMode } from '../hooks/useThemeMode';
import { useNav } from '../context/NavContext';
import LeftNav from '../components/common/LeftNav';

/**
 * Main layout component that wraps all pages and includes the LeftNav and TopNav
 * @param {Object} props - The component props
 * @returns {JSX.Element} The layout component
 */
const StudentLayout = ({ children }) => {
  const { isOnPhone, forceClose, navExpanded: isNavExpanded } = useResponsive();
  const { isLightMode } = useThemeMode();
  const {
    handleNewConversation,
    handleSearchWithText,
    handleNetworkingClick,
    toggleNavExpanded,
    navExpanded,
  } = useNav();

  return (
      <div className="flex flex-row flex-1 overflow-hidden h-full">
        {/* Left Navigation */}
        <LeftNav
          isPhone={isOnPhone}
          isExpanded={(navExpanded && isNavExpanded) && !forceClose}
          onNewConversation={handleNewConversation}
          toggleNavExpanded={toggleNavExpanded}
        />

        {/* Main Content */}
        <div className="flex-1 p-2 transition-all duration-300 font-Poppins overflow-auto">
          {children}
        </div>
      </div>
  );
};

export default StudentLayout;